import { Outlet } from "react-router-dom";

import { FilterBranchProvider } from "./filter-branch/filter-branch.context";
import './branch.scss';

export function Branch() {
  return (
    <div id="ShellBranch" className="branch">
       <FilterBranchProvider>
        <Outlet />
      </FilterBranchProvider>
    </div>
  );
}

export default Branch;
